var _rect, _rect2, _rect3, _rect4, _rect5, _mask, _g, _path, _mask2, _g2, _path2, _mask3, _g3, _path3, _mask4, _g4, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _mask5, _g5, _path14, _mask6, _g6, _path15, _mask7, _g7, _path16, _mask8, _g8, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampusMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1180,
    height: 616,
    viewBox: "0 0 1180 616",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1180,
    height: 616,
    rx: 8,
    fill: "#E4E4EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1133,
    y: 569,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F2F2F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1133,
    y: 498,
    width: 32,
    height: 65,
    rx: 6,
    fill: "#F2F2F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 586,
    width: 76,
    height: 12,
    rx: 6,
    fill: "#F2F2F5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 586,
    width: 55,
    height: 12,
    rx: 6,
    fill: "#F2F2F5"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 541,
    y: 434,
    width: 47,
    height: 93
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.402,
    y: 434.199,
    width: 46.2388,
    height: 92.7889,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M724.532 439.77L504.336 589.093",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.418 404.429L452.223 553.752",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.048 437.407L500.852 586.73",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.934 402.067L448.738 551.39",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.565 435.044L497.369 584.368",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.45 399.704L445.254 549.027",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.08 432.682L493.884 582.005",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.966 397.341L441.77 546.664",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.597 430.319L490.401 579.642",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.483 394.979L438.287 544.302",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.112 427.957L486.916 577.28",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.999 392.616L434.803 541.939",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.628 425.594L483.432 574.917",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.515 390.254L431.319 539.577",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.146 423.231L479.95 572.555",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.031 387.891L427.835 537.214",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.66 420.869L476.464 570.192",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.546 385.528L424.35 534.851",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.177 418.506L472.981 567.829",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.063 383.166L420.867 532.489",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.693 416.144L469.497 565.467",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.579 380.803L417.383 530.126",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.209 413.781L466.013 563.104",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.095 378.44L413.899 527.764",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.725 411.418L462.529 560.741",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.61 376.078L410.414 525.401",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.24 409.056L459.044 558.379",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.127 373.715L406.931 523.038",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.757 406.693L455.561 556.016",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.642 371.353L403.446 520.676",
    stroke: "#F2F2F5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M541.875 526.988V434.199H587.641V526.988",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 385,
    y: 88,
    width: 48,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.7 107.478V104.318V89.3203C385.7 88.768 386.148 88.3203 386.7 88.3203H431.883C432.435 88.3203 432.883 88.768 432.883 89.3203V94.9994C432.883 95.5517 432.435 95.9994 431.883 95.9994H418.312C417.76 95.9994 417.312 96.4471 417.312 96.9994V107.478C417.312 108.03 416.865 108.478 416.312 108.478H386.7C386.148 108.478 385.7 108.03 385.7 107.478Z",
    fill: "#8F90A6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.246 57.7344L350.05 207.057",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.131 22.3945L297.935 171.718",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.761 55.3726L346.565 204.696",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.647 20.0317L294.451 169.355",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.278 53.0098L343.082 202.333",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.163 17.6689L290.967 166.992",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.793 50.647L339.597 199.97",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.679 15.3066L287.483 164.63",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.309 48.2847L336.113 197.608",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.195 12.9438L283.999 162.267",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.825 45.9219L332.629 195.245",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.711 10.5815L280.515 159.905",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.342 43.5596L329.146 192.883",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.228 8.21875L277.032 157.542",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.857 41.1963L325.661 190.519",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.743 5.85596L273.547 155.179",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.374 38.834L322.178 188.157",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.26 3.49365L270.064 152.817",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.89 36.4712L318.694 185.794",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.776 1.13086L266.58 150.454",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.406 34.1089L315.21 183.432",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.292 -1.23145L263.096 148.092",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.923 31.7466L311.727 181.07",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.808 -3.59424L259.612 145.729",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.438 29.3833L308.242 178.706",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.324 -5.95703L256.128 143.366",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.954 27.021L304.758 176.344",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.84 -8.31934L252.644 141.004",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.471 24.6582L301.275 173.981",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.356 -10.6821L249.161 138.641",
    stroke: "#F2F2F5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M385.7 107.478V104.318V89.3203C385.7 88.768 386.148 88.3203 386.7 88.3203H431.883C432.435 88.3203 432.883 88.768 432.883 89.3203V94.9994C432.883 95.5517 432.435 95.9994 431.883 95.9994H418.312C417.76 95.9994 417.312 96.4471 417.312 96.9994V107.478C417.312 108.03 416.865 108.478 416.312 108.478H386.7C386.148 108.478 385.7 108.03 385.7 107.478Z",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 693,
    y: 88,
    width: 51,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.33 94.0395V89.3203C693.33 88.768 693.777 88.3203 694.33 88.3203H742.815C743.367 88.3203 743.815 88.768 743.815 89.3203V94.0395C743.815 94.5918 743.367 95.0395 742.815 95.0395H729.245C728.692 95.0395 728.245 95.4872 728.245 96.0395V107.478C728.245 108.03 727.797 108.478 727.245 108.478H709.428C708.876 108.478 708.428 108.03 708.428 107.478V96.0395C708.428 95.4872 707.98 95.0395 707.428 95.0395H694.33C693.777 95.0395 693.33 94.5918 693.33 94.0395Z",
    fill: "#8F90A6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.938 57.7363L658.743 207.059",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.826 22.3945L606.63 171.718",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.456 55.3726L655.26 204.696",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.341 20.0322L603.145 169.355",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.973 53.0098L651.777 202.333",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.857 17.6689L599.661 166.992",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.487 50.647L648.291 199.97",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.374 15.3066L596.178 164.63",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.004 48.2847L644.808 197.608",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.89 12.9438L592.694 162.267",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.52 45.9219L641.324 195.245",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.406 10.5815L589.21 159.905",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.036 43.5596L637.84 192.883",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.921 8.21924L585.725 157.542",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.553 41.1968L634.357 190.52",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.438 5.85596L582.242 155.179",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.067 38.834L630.871 188.157",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.954 3.49365L578.758 152.817",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.584 36.4717L627.388 185.795",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.47 1.13086L575.274 150.454",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.1 34.1089L623.904 183.432",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.986 -1.23145L571.79 148.092",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.616 31.7466L620.42 181.07",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.502 -3.59424L568.306 145.729",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.132 29.3833L616.936 178.706",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.018 -5.95703L564.822 143.366",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.648 27.021L613.452 176.344",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.534 -8.31934L561.338 141.004",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.165 24.6587L609.969 173.982",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.05 -10.6821L557.854 138.641",
    stroke: "#F2F2F5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M693.33 94.0395V89.3203C693.33 88.768 693.777 88.3203 694.33 88.3203H742.815C743.367 88.3203 743.815 88.768 743.815 89.3203V94.0395C743.815 94.5918 743.367 95.0395 742.815 95.0395H729.245C728.692 95.0395 728.245 95.4872 728.245 96.0395V107.478C728.245 108.03 727.797 108.478 727.245 108.478H709.428C708.876 108.478 708.428 108.03 708.428 107.478V96.0395C708.428 95.4872 707.98 95.0395 707.428 95.0395H694.33C693.777 95.0395 693.33 94.5918 693.33 94.0395Z",
    stroke: "#F2F2F5",
    strokeWidth: 2
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1011,
    y: 88,
    width: 48,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1058.52 107.478V104.318V89.3203C1058.52 88.768 1058.07 88.3203 1057.52 88.3203H1012.34C1011.79 88.3203 1011.34 88.768 1011.34 89.3203V94.9994C1011.34 95.5517 1011.79 95.9994 1012.34 95.9994H1025.91C1026.46 95.9994 1026.91 96.4471 1026.91 96.9994V107.478C1026.91 108.03 1027.36 108.478 1027.91 108.478H1057.52C1058.07 108.478 1058.52 108.03 1058.52 107.478Z",
    fill: "#8F90A6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1195.06 57.7358L974.867 207.059",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.95 22.394L922.754 171.717",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.58 55.3721L971.385 204.695",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.46 20.0317L919.269 169.355",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.1 53.0093L967.9 202.332",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.98 17.6689L915.786 166.992",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.61 50.647L964.417 199.97",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.5 15.3066L912.302 164.63",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.13 48.2842L960.934 197.607",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.01 12.9438L908.819 162.267",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.64 45.9219L957.449 195.245",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.53 10.5815L905.334 159.905",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.16 43.5591L953.963 192.882",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.05 8.21875L901.85 157.542",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.68 41.1963L950.481 190.519",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.56 5.85596L898.367 155.179",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.19 38.834L946.996 188.157",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.08 3.49316L894.883 152.816",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.71 36.4712L943.511 185.794",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.59 1.13086L891.398 150.454",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.22 34.1089L940.029 183.432",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.11 -1.23145L887.915 148.092",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.74 31.7461L936.545 181.069",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.63 -3.59473L884.432 145.728",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.26 29.3833L933.061 178.706",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.14 -5.95703L880.948 143.366",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.77 27.021L929.577 176.344",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.66 -8.31982L877.463 141.003",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.29 24.6582L926.094 173.981",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.18 -10.6821L873.98 138.641",
    stroke: "#F2F2F5"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.52 107.478V104.318V89.3203C1058.52 88.768 1058.07 88.3203 1057.52 88.3203H1012.34C1011.79 88.3203 1011.34 88.768 1011.34 89.3203V94.9994C1011.34 95.5517 1011.79 95.9994 1012.34 95.9994H1025.91C1026.46 95.9994 1026.91 96.4471 1026.91 96.9994V107.478C1026.91 108.03 1027.36 108.478 1027.91 108.478H1057.52C1058.07 108.478 1058.52 108.03 1058.52 107.478Z",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M795 528.268L1046.5 528.268",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M970.762 448.277V527.947",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.06 448.277H1011.5M839.124 448.277H985.5",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M831 527.948L834 491M819.307 316.133H915.087M959.438 316.133H1082.5M849.503 316.133L836.5 463",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9434 279.977H107.323V265.579H141.767M186.59 265.579H196.97M246.512 265.579H196.97M290.863 265.579H352.2M396.08 265.579H406.932V108.798M196.97 104.958V265.579",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M302.187 104.958V265.259",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M716.449 527.628H97C96.4477 527.628 96 527.18 96 526.628V105.318C96 104.766 96.4477 104.318 97 104.318H384.7C385.252 104.318 385.7 103.87 385.7 103.318V89C385.7 88.4477 386.148 88 386.7 88H1057.99C1058.55 88 1058.99 88.4477 1058.99 89V107.158C1058.99 107.71 1059.44 108.158 1059.99 108.158H1082.06C1082.61 108.158 1083.06 108.605 1083.06 109.158V141M1083.06 528.5V211.5",
    stroke: "#F2F2F5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M398.911 527.628V316.453H649.922M692.858 316.453H732.019V392.924L602.739 398.043L640.013 316.453",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186 347H153V470H343V347H217.5",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 522,
    y: 250,
    width: 26,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522 265.158V262.823V251C522 250.448 522.448 250 523 250H546.339C546.891 250 547.339 250.448 547.339 251V265.158C547.339 265.71 546.891 266.158 546.339 266.158H523C522.448 266.158 522 265.71 522 265.158Z",
    fill: "#8F90A6"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.924 225.484L493.423 345.176",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.151 197.156L451.65 316.848",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.132 223.59L490.631 343.282",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.359 195.262L448.858 314.954",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.34 221.696L487.839 341.388",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.566 193.369L446.065 313.061",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.546 219.802L485.045 339.494",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.774 191.475L443.273 311.167",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.754 217.909L482.253 337.601",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.981 189.581L440.48 309.273",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.961 216.015L479.46 335.707",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.189 187.688L437.688 307.379",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.169 214.122L476.668 333.814",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.396 185.793L434.895 305.485",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.376 212.227L473.875 331.919",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.604 183.899L432.102 303.591",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.584 210.333L471.083 330.025",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.812 182.006L429.31 301.698",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.791 208.439L468.29 328.131",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.019 180.112L426.518 299.804",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.999 206.546L465.498 326.238",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.226 178.219L423.725 297.911",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.207 204.652L462.706 324.344",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.434 176.325L420.933 296.017",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.414 202.758L459.913 322.45",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.641 174.431L418.14 294.123",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.621 200.865L457.12 320.557",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.848 172.537L415.347 292.229",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.829 198.971L454.328 318.663",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.056 170.643L412.555 290.335",
    stroke: "#F2F2F5"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M522 265.158V262.823V251C522 250.448 522.448 250 523 250H546.339C546.891 250 547.339 250.448 547.339 251V265.158C547.339 265.71 546.891 266.158 546.339 266.158H523C522.448 266.158 522 265.71 522 265.158Z",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 662,
    y: 250,
    width: 26,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M662 265.158V262.823V251C662 250.448 662.448 250 663 250H686.339C686.891 250 687.339 250.448 687.339 251V265.158C687.339 265.71 686.891 266.158 686.339 266.158H663C662.448 266.158 662 265.71 662 265.158Z",
    fill: "#8F90A6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M809.924 225.484L633.423 345.176",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.151 197.156L591.65 316.848",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.132 223.59L630.631 343.282",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.359 195.262L588.858 314.954",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.34 221.696L627.839 341.388",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.566 193.369L586.065 313.061",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.546 219.802L625.045 339.494",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.774 191.475L583.273 311.167",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.754 217.909L622.253 337.601",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.981 189.581L580.48 309.273",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.961 216.015L619.46 335.707",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.189 187.688L577.688 307.379",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.169 214.122L616.668 333.814",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.396 185.793L574.895 305.485",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.376 212.227L613.875 331.919",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.604 183.899L572.102 303.591",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.584 210.333L611.083 330.025",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.812 182.006L569.31 301.698",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.791 208.439L608.29 328.131",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.019 180.112L566.518 299.804",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.999 206.546L605.498 326.238",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.226 178.219L563.725 297.911",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.207 204.652L602.706 324.344",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.434 176.325L560.933 296.017",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.414 202.758L599.913 322.45",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.641 174.431L558.14 294.123",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.621 200.865L597.12 320.557",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.848 172.537L555.347 292.229",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.829 198.971L594.328 318.663",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.056 170.643L552.555 290.335",
    stroke: "#F2F2F5"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M662 265.158V262.823V251C662 250.448 662.448 250 663 250H686.339C686.891 250 687.339 250.448 687.339 251V265.158C687.339 265.71 686.891 266.158 686.339 266.158H663C662.448 266.158 662 265.71 662 265.158Z",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 802,
    y: 250,
    width: 26,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802 265.158V262.823V251C802 250.448 802.448 250 803 250H826.339C826.891 250 827.339 250.448 827.339 251V265.158C827.339 265.71 826.891 266.158 826.339 266.158H803C802.448 266.158 802 265.71 802 265.158Z",
    fill: "#8F90A6"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M949.924 225.484L773.423 345.176",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.151 197.156L731.65 316.848",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.132 223.59L770.631 343.282",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.359 195.262L728.858 314.954",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.34 221.696L767.839 341.388",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.566 193.369L726.065 313.061",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.547 219.802L765.046 339.494",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.774 191.475L723.273 311.167",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.754 217.909L762.253 337.601",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.981 189.581L720.48 309.273",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.961 216.015L759.46 335.707",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.189 187.688L717.688 307.379",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.169 214.122L756.668 333.814",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.396 185.793L714.895 305.485",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.376 212.227L753.875 331.919",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.604 183.899L712.102 303.591",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.584 210.333L751.083 330.025",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.812 182.006L709.31 301.698",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.791 208.439L748.29 328.131",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.019 180.112L706.518 299.804",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.998 206.546L745.497 326.238",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.226 178.219L703.725 297.911",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.207 204.652L742.706 324.344",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.434 176.325L700.933 296.017",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.413 202.758L739.912 322.45",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.641 174.431L698.14 294.123",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.621 200.865L737.12 320.557",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.848 172.537L695.347 292.229",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.829 198.971L734.328 318.663",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.056 170.643L692.555 290.335",
    stroke: "#F2F2F5"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M802 265.158V262.823V251C802 250.448 802.448 250 803 250H826.339C826.891 250 827.339 250.448 827.339 251V265.158C827.339 265.71 826.891 266.158 826.339 266.158H803C802.448 266.158 802 265.71 802 265.158Z",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 942,
    y: 250,
    width: 26,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M942 265.158V262.823V251C942 250.448 942.448 250 943 250H966.339C966.891 250 967.339 250.448 967.339 251V265.158C967.339 265.71 966.891 266.158 966.339 266.158H943C942.448 266.158 942 265.71 942 265.158Z",
    fill: "#8F90A6"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1089.92 225.484L913.423 345.176",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.15 197.156L871.65 316.848",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.13 223.59L910.631 343.282",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.36 195.262L868.858 314.954",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.34 221.696L907.839 341.388",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.57 193.369L866.065 313.061",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.55 219.802L905.046 339.494",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.77 191.475L863.273 311.167",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.75 217.909L902.253 337.601",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.98 189.581L860.48 309.273",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.96 216.015L899.46 335.707",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.19 187.688L857.687 307.379",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.17 214.122L896.668 333.814",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.4 185.793L854.895 305.485",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.38 212.227L893.875 331.919",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.6 183.899L852.102 303.591",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.58 210.333L891.083 330.025",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.81 182.006L849.31 301.698",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.79 208.439L888.29 328.131",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.02 180.112L846.518 299.804",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062 206.546L885.497 326.238",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.23 178.219L843.725 297.911",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.21 204.652L882.706 324.344",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.43 176.325L840.933 296.017",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.41 202.758L879.912 322.45",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.64 174.431L838.14 294.123",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.62 200.865L877.12 320.557",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.85 172.537L835.348 292.229",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.83 198.971L874.328 318.663",
    stroke: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.06 170.643L832.555 290.335",
    stroke: "#F2F2F5"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M942 265.158V262.823V251C942 250.448 942.448 250 943 250H966.339C966.891 250 967.339 250.448 967.339 251V265.158C967.339 265.71 966.891 266.158 966.339 266.158H943C942.448 266.158 942 265.71 942 265.158Z",
    stroke: "#F2F2F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampusMap);
export default __webpack_public_path__ + "static/media/campus_map.42b7e5782a4be96f99e29114bd3fe507.svg";
export { ForwardRef as ReactComponent };